import { render, staticRenderFns } from "./TemplateSettingAdd.vue?vue&type=template&id=60b1671f&scoped=true"
import script from "./TemplateSettingAdd.vue?vue&type=script&lang=js"
export * from "./TemplateSettingAdd.vue?vue&type=script&lang=js"
import style0 from "./TemplateSettingAdd.vue?vue&type=style&index=0&id=60b1671f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1671f",
  null
  
)

export default component.exports